import CloseIcon from "@mui/icons-material/Close";
import "./NavbarMenu.css";
import { useAccessRights } from "../../../hooks/userPermissions/useAccessRights";

const NavbarMenu = ({
  showNavbarMenu,
  onShowNavbarMenu,
  onToggleHistoricSidebar,
  onToggleSidebar,
  handleDraggableComponentToggle,
  handleMeteoComponentToggle,
  toggleMapStylesSidebar,
  onShowHistoricFiresList,
  handleLegendComponentToggle,
  onShowUserComponent,
  onOpenLegendComponent,
  logout,
  onToggleActiveFiresPanel,
}) => {
  const { isServiceEnabled } = useAccessRights();

  // Check if services are enabled
  const isHistoricEnabled = isServiceEnabled("historic_fire_service");
  const isLayersEnabled = isServiceEnabled("display_layers_service");
  const isWeatherEnabled = isServiceEnabled("weather");
  const isEventCreationEnabled = isServiceEnabled("physical_model");
  // const isActiveFiresEnabled = isServiceEnabled("active_fires");
  const isActiveFiresEnabled = true;
  const onOpenHistoricFiresSidebar = () => {
    if (!isHistoricEnabled) return;
    onToggleHistoricSidebar();
    onShowHistoricFiresList();
    onShowNavbarMenu();
  };
  const onOpenUserProfile = () => {
    onShowUserComponent();
    onShowNavbarMenu(true);
  };
  const onOpenLayersComponent = () => {
    if (!isLayersEnabled) return;
    handleDraggableComponentToggle();
    onShowNavbarMenu(true);
  };

  const onOpenMetoComponent = () => {
    if (!isWeatherEnabled) return;
    handleMeteoComponentToggle();
    onShowNavbarMenu(true);
  };

  const onOpenOperationalFlow = () => {
    if (!isEventCreationEnabled) return;
    onToggleSidebar();
    onShowNavbarMenu(true);
  };
  const onOpenMapStyleComponent = () => {
    toggleMapStylesSidebar();
    onShowNavbarMenu(true);
  };
  const onOpenActiveFiresComponent = () => {
    if (!isActiveFiresEnabled) return;
    onToggleActiveFiresPanel();
    onShowNavbarMenu(true);
  };
  return (
    <div className={`sidebar-menu ${showNavbarMenu ? "open" : ""}`}>
      <div className="drag-comp-header">
        <div className="drag-comp-title">Menu</div>
        <CloseIcon onClick={onShowNavbarMenu} className="drag-comp-closeIcon" />
      </div>
      <div className="drag-comp_body">
        <div
          className={`sidebar-section ${!isHistoricEnabled ? "disabled" : ""}`}
          onClick={onOpenHistoricFiresSidebar}
          data-testid="navbarmenu-historical-fires-button"
        >
          <div className="sidebar-section-header">
            Historique des feux
            {!isHistoricEnabled && " 🔒"}
          </div>
        </div>

        <div
          className={`sidebar-section ${!isLayersEnabled ? "disabled" : ""}`}
          onClick={onOpenLayersComponent}
          data-testid="navbarmenu-layers-button"
        >
          <div className="sidebar-section-header">
            Couches
            {!isLayersEnabled && " 🔒"}
          </div>
        </div>

        <div
          className="sidebar-section"
          onClick={onOpenMapStyleComponent}
          data-testid="navbarmenu-map-style-button"
        >
          <div className="sidebar-section-header">Fond de carte</div>
        </div>

        <div
          className={`sidebar-section ${!isWeatherEnabled ? "disabled" : ""}`}
          onClick={onOpenMetoComponent}
          data-testid="navbarmenu-weather-button"
        >
          <div className="sidebar-section-header">
            Météo
            {!isWeatherEnabled && " 🔒"}
          </div>
        </div>
        <div
          className={`sidebar-section ${!isActiveFiresEnabled ? "disabled" : ""}`}
          onClick={onOpenActiveFiresComponent}
          data-testid="navbarmenu-active-fires-button"
        >
          <div className="sidebar-section-header">
            Points chauds
            {!isActiveFiresEnabled && " 🔒"}
          </div>
        </div>
        <div
          className={`sidebar-section ${!isEventCreationEnabled ? "disabled" : ""}`}
          onClick={onOpenOperationalFlow}
          data-testid="navbarmenu-create-event-button"
        >
          <div className="sidebar-section-header">
            Créer un événement
            {!isEventCreationEnabled && " 🔒"}
          </div>
        </div>

        <div
          className="sidebar-section"
          onClick={onOpenLegendComponent}
          data-testid="navbarmenu-legend-button"
        >
          <div className="sidebar-section-header">Légende</div>
        </div>

        <div
          className="sidebar-section"
          onClick={onOpenUserProfile}
          data-testid="navbarmenu-user-menu-button"
        >
          <div className="sidebar-section-header">Profile</div>
        </div>
        <div
          className="sidebar-section"
          onClick={logout}
          data-testid="navbarmenu-logout-button"
        >
          <div className="sidebar-section-header" style={{ color: "red" }}>
            Déconnexion
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarMenu;
